/**
 * Route name keys (as passed to `routeNames.get`) whose pages hide the auction access
 * banner, mobile announcements carousel, and TOS acceptance modal - chrome that would
 * interrupt a login, logout, or registration flow.
 */
const ANNOUNCEMENT_EXCLUDED_ROUTE_KEYS = [
  'registrationForm',
  'registrationForm_v2',
  'registration_v2',
  'login',
  'logout',
  'forgot',
  'registrationDealerships',
  'registrationDealerships_v2',
  'registrationEmailVerification_v2',
  'registrationIdentityVerified_v2',
  'registrationAcvAccountCreation_v2',
  'registrationAcvAccountCreationSuccess_v2',
  'registrationAcvLogin_v2',
  'registrationAcvLoginSuccess_v2',
  'registrationDealerForm_v2',
];

export default ANNOUNCEMENT_EXCLUDED_ROUTE_KEYS;
